"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.IconButton = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _coreIcon = _interopRequireDefault(require("@legacy-vfuk/core-icon"));

var _coreLoadingSpinner = _interopRequireDefault(require("@legacy-vfuk/core-loading-spinner"));

var _IconButton = _interopRequireDefault(require("./themes/IconButton.theme"));

var Styled = _interopRequireWildcard(require("./styles/IconButton.style"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var IconButton = /*#__PURE__*/function (_PureComponent) {
  _inherits(IconButton, _PureComponent);

  var _super = _createSuper(IconButton);

  function IconButton() {
    _classCallCheck(this, IconButton);

    return _super.apply(this, arguments);
  }

  _createClass(IconButton, [{
    key: "render",
    value: function render() {
      var localTheme = (0, _IconButton["default"])(this.props.theme);
      var localThemeAppearance = localTheme.appearance[this.props.appearance];
      var isDisabledOrLoading = this.props.state === 'disabled' || this.props.loading;
      return /*#__PURE__*/_react["default"].createElement(Styled.IconButton, {
        appearance: this.props.appearance,
        target: this.props.htmlAttributes.target,
        type: this.props.htmlAttributes.type,
        dataAttributes: this.props.htmlAttributes.dataAttributes,
        size: this.props.size,
        shape: this.props.shape,
        inverse: this.props.inverse,
        state: this.props.state,
        onInteraction: this.props.onClick,
        onMouseDown: this.props.onMouseDown,
        onMouseUp: this.props.onMouseUp,
        onTouchStart: this.props.onTouchStart,
        onTouchEnd: this.props.onTouchEnd,
        disabled: isDisabledOrLoading,
        label: this.props.srText,
        to: !isDisabledOrLoading ? this.props.to : undefined,
        href: !isDisabledOrLoading ? this.props.href : undefined,
        id: this.props.id,
        customRouterProps: this.props.customRouterProps
      }, this.props.loading ? /*#__PURE__*/_react["default"].createElement(Styled.LoadingIcon, null, /*#__PURE__*/_react["default"].createElement(_coreLoadingSpinner["default"], {
        appearance: this.props.inverse ? localThemeAppearance.inverse.loadingSpinnerAppearance : localThemeAppearance.loadingSpinnerAppearance,
        inverse: this.props.inverse ? localThemeAppearance.inverse.inverseIcon : localThemeAppearance.inverseIcon,
        size: localTheme.size[this.props.size].loadingSpinnerSize
      })) : /*#__PURE__*/_react["default"].createElement(_coreIcon["default"], {
        name: this.props.icon.name,
        size: localTheme.size[this.props.size].iconSize
      }));
    }
  }]);

  return IconButton;
}(_react.PureComponent);

exports.IconButton = IconButton;
IconButton.defaultProps = {
  shape: 'square',
  size: 6,
  appearance: 'primary',
  htmlAttributes: {}
};
IconButton.displayName = "IconButton";

var _default = (0, _styledComponents.withTheme)(IconButton);

exports["default"] = _default;
//# sourceMappingURL=IconButton.js.map